import { render } from "./DataDuplication.vue?vue&type=template&id=39ab55ad&scoped=true"
import script from "./DataDuplication.vue?vue&type=script&lang=js"
export * from "./DataDuplication.vue?vue&type=script&lang=js"

import "./DataDuplication.vue?vue&type=style&index=0&id=39ab55ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ab55ad"]])

export default __exports__